export default __webpack_public_path__ + "static/t-topshot-460c7ff5f68e190d537b0e1540a2782e.png";